export function isCnpjLikeValue(value) {
  const normalizedValue = value?.trim();

  if (!normalizedValue) {
    return false;
  }

  return /^[\d./-]+$/.test(normalizedValue);
}

export function hasCompleteCnpjValue(value) {
  if (!isCnpjLikeValue(value)) {
    return false;
  }

  return value.replace(/\D/g, '').length === 14;
}
